module.exports = __webpack_public_path__ + "img/line-end-5.7a63d8e0.svg";